import logo from '../assets/secondary_red.svg';
import '../styles/App.css';
import React from 'react';
import { Header } from './ui';
import {Container, Typography, } from '@mui/material'

import Menu from './Menu';
import config  from '../utils/config';


import { QueryContextProvider } from './QueryContext';
import Query from './Query';
import Responses from './Responses';
import '../styles/index.scss';


function Main() {

  const [open, setOpen] = React.useState(true);
  const [everClosed, setEverClosed] = React.useState(false);

  const [selectedProduct, setSelectedProduct] = React.useState(
    // window.sessionStorage.getItem("product")
    "MBSecure"
  );
  const [selectedVersion, setSelectedVersion] = React.useState(
    // window.sessionStorage.getItem("version")
    ""
  );

  const products = config.products
  const versions = config.products[selectedProduct] || [];
  const filteredVersions = versions.filter(version => version.trim() !== '');

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEverClosed(true);
  };
  
  const handleVersionButtonClick = React.useCallback((value) => {
    setSelectedVersion(value);
  }, []);

  const handleProductButtonClick = React.useCallback((value) => {
    setSelectedProduct(value);
    console.log("config products", config.products[value]?.[0] || "");
    setSelectedVersion(config.products[value]?.[0] || "");
  }, []);

  return (
    <Container>
      <Header
        logo={<img src={logo} alt="Logo" width="350" />}
        onMenuClick={handleOpen}
        rightSlot={<Typography variant="h5" fontWeight="bold" sx={{ color: '#330000' }}>HelpBot</Typography>}
        showMenuToggle
      />

      <Menu
          open={open}
          handleClose={handleClose}
          animated={everClosed}
          // selectedAction={selectedAction}
          // handleActionButtonClick={handleActionButtonClick}
          selectedProduct={selectedProduct}
          handleProductButtonClick={handleProductButtonClick}
          selectedVersion={selectedVersion}
          handleVersionButtonClick={handleVersionButtonClick}
          filteredVersions={filteredVersions}
          language={"en-US"}
          // handleLanguageChange={handleLanguageChange}
          username={sessionStorage.getItem('username')}
          products={products}
          // buildNumber={buildNumber}
        />

      <main>
          <QueryContextProvider>
            <Responses product={selectedProduct}
                        vers={selectedVersion} language={"en-US"}
                        classification={"nlh"}>
            </Responses>    
            <Query language="en-US" disabled={false}></Query>
          </QueryContextProvider>
      </main>
    </Container>
  );
}

export default Main;
